import getCanvas from '../helpers/getCanvas';

const isInputField = (node) => node.nodeName === 'INPUT' && node.type === 'text';

const textNodeToLabel = (html) => {
  const canvas = getCanvas(html);
  const form = canvas.querySelector('form');

  if (!form) {
    return html;
  }

  const childNodes = form.childNodes;
  let textNode;

  if (canvas.querySelectorAll('label, input[placeholder]').length) {
    return html;
  }

  Array.from(childNodes).forEach((node, index) => {
    if (isInputField(node)) {
      textNode = childNodes[index - 1];
      node.setAttribute('placeholder', textNode.nodeValue.trim());
    }
  });

  return canvas.innerHTML;
};

export default textNodeToLabel;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/textNodeToPlaceholder.js
 **/